import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiDivider: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: {
      borderColor: Colors.DividersAndCardBorders,
    },
  },
};

export default MuiDivider;
